import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  getMerchantDefaultRoute,
  MerchantAuthProvider,
  useMerchantAuthState,
  useMerchantAuthUser,
} from "../auth/MerchantAuthContext";
import MerchantLayout from "../layout/MerchantLayout";
import MerchantLoginPage from "../pages/MerchantLoginPage";
import MerchantRegisterPage from "../pages/MerchantRegisterPage";
import MerchantSettlementReportPage from "../pages/MerchantSettlementReportPage";
import "../styles/merchant.css";

export function MerchantPrivateRoute({ component, ...rest }) {
  const isAuthenticated = useMerchantAuthState();

  return (
    <Route
      {...rest}
      render={function renderPrivateRoute(props) {
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          );
        }

        return React.createElement(component, props);
      }}
    />
  );
}

export function MerchantPublicRoute({ component, ...rest }) {
  const isAuthenticated = useMerchantAuthState();
  const merchantUser = useMerchantAuthUser();

  return (
    <Route
      {...rest}
      render={function renderPublicRoute(props) {
        return isAuthenticated ? (
          <Redirect to={getMerchantDefaultRoute(merchantUser)} />
        ) : (
          React.createElement(component, props)
        );
      }}
    />
  );
}

function MerchantRouteSwitch() {
  const isAuthenticated = useMerchantAuthState();
  const merchantUser = useMerchantAuthUser();

  return (
    <Switch>
      <Route
        exact
        path="/"
        render={function renderMerchantRoot() {
          return (
            <Redirect
              to={isAuthenticated ? getMerchantDefaultRoute(merchantUser) : "/login"}
            />
          );
        }}
      />
      <MerchantPublicRoute exact path="/login" component={MerchantLoginPage} />
      <MerchantPublicRoute exact path="/register" component={MerchantRegisterPage} />
      <MerchantPrivateRoute
        exact
        path="/settlements/:summaryId/report"
        component={MerchantSettlementReportPage}
      />
      <MerchantPrivateRoute path="/" component={MerchantLayout} />
    </Switch>
  );
}

export default function MerchantRoutes() {
  return (
    <MerchantAuthProvider>
      <MerchantRouteSwitch />
    </MerchantAuthProvider>
  );
}
